export default __webpack_public_path__ + "static/media/MSC17013313.a62b503d.jpg";